import type { ApiGroup } from '@Model';
import type { AsyncStateUpdate, Awaitable } from '@synqo/frontend-component-library';
import { useCallback } from 'react';

export const useGroupPermissions = (requestUpdateState: AsyncStateUpdate<ApiGroup>) => {
    // @ai-generated 2026-06-19T20:56:25Z by matthias.gessinger@synqony.com using Opus 4.8
    const updatePermissions = useCallback(
        (newKeys: string[]): Awaitable<boolean> =>
            requestUpdateState((latest, saveData) => saveData({ ...latest, permissions: newKeys })),
        [requestUpdateState],
    );

    return {
        updatePermissions,
    };
};
